import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { MODELS, SITE } from "@/data/content";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="rb-footer" data-testid="site-footer">
      <div className="container-rb">
        <div className="rb-footer__grid">
          <div className="rb-footer__brand">
            <Link to="/" className="rb-logo" aria-label="RB TIM">
              <img
                src="/images/logo-rbtim.png"
                alt="RB TIM logo"
                className="rb-logo__img rb-logo__img--footer"
              />
            </Link>
            <p className="rb-footer__desc">{SITE.description}</p>
            <div style={{ marginTop: 4, fontSize: 13, color: "#94a3b8" }}>
              {SITE.fullAddress}
            </div>
          </div>

          <div>
            <h4>Modeli</h4>
            <ul>
              {MODELS.map((m) => (
                <li key={m.slug}>
                  <Link to={`/${m.slug}`} data-testid={`footer-link-${m.key}`}>{m.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4>Stranice</h4>
            <ul>
              <li><Link to="/">Početna</Link></li>
              <li><Link to="/modeli-kontejnera">Modeli kontejnera</Link></li>
              <li><Link to="/galerija">Galerija</Link></li>
              <li><Link to="/o-nama">O nama</Link></li>
              <li><Link to="/kontakt">Kontakt</Link></li>
            </ul>
          </div>

          <div>
            <h4>Kontakt</h4>
            <ul>
              <li style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <Phone size={16} /> <a href={SITE.phoneHref} data-testid="footer-phone">{SITE.phone}</a>
              </li>
              <li style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <Mail size={16} /> <a href={SITE.emailHref} data-testid="footer-email">{SITE.email}</a>
              </li>
              <li style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
                <MapPin size={16} style={{ marginTop: 2, flex: "0 0 auto" }} />
                <span>{SITE.address}</span>
              </li>
              <li style={{ display: "flex", gap: 8, alignItems: "flex-start", marginTop: 8 }}>
                <Clock size={16} style={{ marginTop: 2, flex: "0 0 auto" }} />
                <div>
                  {SITE.hours.map((h) => (
                    <div key={h.day} style={{ fontSize: 13 }}>
                      <span style={{ color: "#94a3b8" }}>{h.day}:</span>{" "}
                      <strong style={{ color: "#fff" }}>{h.value}</strong>
                    </div>
                  ))}
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="rb-footer__bottom">
          <span>© {year} {SITE.name}. Sva prava zadržana.</span>
          <span>Standardni kontejneri za praktičnu upotrebu.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
